import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, DialogTrigger, SpinButton, Spinner, Subtitle2, tokens } from "@fluentui/react-components";
import { useEffect, useState } from "react";
import HUDMainPanel from "./components/HUDMainPanel";

export default function HUDManagePage() {
    const [ loading, setLoading ] = useState<boolean>( true );
    const [ loadingError, setLoadingError ] = useState<string | null>( null );
    const [ userDisplayName, setUserDisplayName ] = useState<string>( "Unknown User" );

    useEffect(
        () => {
            let hak = new URLSearchParams( window.location.search ).get( "hak" );
            if( hak ) {
                sessionStorage.setItem( "hak", hak );
                window.location.href = window.location.pathname + window.location.hash;
                return;
            }

            hak = sessionStorage.getItem( "hak" ) ?? null;
            if ( hak ) {
                fetch(
                    "/api",
                    {
                        method: "GET",
                        headers: {
                            "X-Hak": hak
                        }
                    }
                ).then(
                    async ( r ) => {
                        if( r.status !== 200 ) {
                            console.error( "Failed to fetch HUD data." );
                            setLoading( false );
                            setLoadingError( "Failed to fetch HUD data. Try clicking the \"Configure\" button on your HUD in-world again." );
                            return;
                        }

                        const result = await r.json();

                        setUserDisplayName( result.userInfo.displayName );
                        setLoading( false );
                    }
                );
            }
            else
            {
                console.warn( "No hak provided, cannot fetch HUD data." );
                setLoading( false );
                setLoadingError( "Please select \"Configure\" on your HUD in-world." );
            }
        },
        []
    );

    return (
        <>
            <div style={{ padding: "2rem 10rem 2rem 10rem" }}>
                {
                    loading ?
                        <div style={{ textAlign: "center" }}>
                            <Spinner size="extra-large" label={<Subtitle2>Loading your HUD information...</Subtitle2>} labelPosition="below" />
                        </div> : null
                }
                { loadingError ? <Subtitle2 style={{ color: tokens.colorStatusDangerForeground1 }}>Error: {loadingError}</Subtitle2> : null }
                {
                    !loading && !loadingError ? <><h1>{userDisplayName}'s Roleplay HUD</h1><HUDMainPanel /></> : null
                }
            </div>
        </>
    );
}